/* SVT Size guide — cm / inch toggle.
   Values for both units are rendered server-side into data-cm / data-in attributes,
   so switching units never needs a round trip and never rounds twice. */
(function () {
  'use strict';

  function wire(root) {
    if (root.dataset.svtSizeGuideReady === '1') return;
    root.dataset.svtSizeGuideReady = '1';

    var buttons = root.querySelectorAll('[data-svt-unit]');
    var cells = root.querySelectorAll('td[data-cm]');
    if (!buttons.length || !cells.length) return;

    function apply(unit) {
      for (var i = 0; i < cells.length; i++) {
        var value = cells[i].getAttribute(unit === 'in' ? 'data-in' : 'data-cm');
        if (value) cells[i].textContent = value;
      }
      for (var j = 0; j < buttons.length; j++) {
        var active = buttons[j].getAttribute('data-svt-unit') === unit;
        buttons[j].classList.toggle('is-active', active);
        buttons[j].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    for (var k = 0; k < buttons.length; k++) {
      buttons[k].addEventListener('click', function (event) {
        event.preventDefault();
        apply(this.getAttribute('data-svt-unit'));
      });
    }

    apply('cm');
  }

  function init() {
    var roots = document.querySelectorAll('[data-svt-size-guide]');
    for (var i = 0; i < roots.length; i++) wire(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders blocks in place; re-wire whatever appears.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
